import React from 'react'
import Switch from 'components/Switch/Switch'

import {styled} from 'stitches/config'
import {
    switchWrapper,
} from './styles'

const StyledSwitchWrapper = styled('div', switchWrapper)

export interface QuestionnaireSwitchProps {
    id: string
    name: string
    readableName?: string
    groupName?: string
    text?: string
    value?: boolean
    onChange: (params: {name: string, value: boolean, readableName?: string, groupName?: string}) => void
}

export const QuestionnaireSwitch = (props: QuestionnaireSwitchProps) => {
    const {
        id, value, onChange, text, name, readableName, groupName, ...other
    } = props

    return (
        <StyledSwitchWrapper>
            <Switch
                id={id}
                label={text}
                on={value}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange({
                    groupName,
                    name,
                    readableName,
                    value: event.target.checked,
                })}
                {...other}
            />

        </StyledSwitchWrapper>
    )
}

QuestionnaireSwitch.defaultProps = {
    groupName: '',
    readableName: '',
    text: '',
    value: false,
}
